import {SubAccountListView} from './SubAccountListView'

/* eslint-disable jsx-a11y/anchor-is-valid */

export function SubAccountView() {
  return (
    <>
      <div className='card-body p-0' style={{minHeight: '45vh'}}>
        <div className='accordion' id='kt_accordion_sub_accounts'>
          <div className='accordion-item'>
            
            <div
              id='kt_accordion_sub_accounts_body_1'
              className='accordion-collapse collapse show'
              aria-labelledby='kt_accordion_sub_accounts_header_1'
              data-bs-parent='#kt_accordion_sub_accounts'
            >
              <div className='accordion-body'>
                <SubAccountListView />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
} 